<template>
    <div class="w-full text-[var(--text)] gap-2 p-4 bg-[var(--fundoComponente)] rounded-[10px] bg-opacity-[0.55] flex flex-col">
        <div class="w-full flex justify-between">
            <h3 class="text-[var(--titulo)]">Orçamento</h3>
            <AppButton class=" self-end text-[var(--text)]" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                        @close="close" :width=23 :height=23 /> 
        </div>

        <div class="flex gap-2 w-full">
            <div class=" left-input-field flex flex-col gap-2">
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="fornecedor">Fornecedor:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="fornecedor" v-model="fornecedor.nome" placeholder="fornecedor">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="numero">Número:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="numero" v-model="model.numero" placeholder="Numero">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Data:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.data" placeholder="Data">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Validade:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.validade" placeholder="Validade">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Prazo:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="model.prazo" placeholder="Prazo">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Moeda:</label>
                    <select style="background-color: var(--label);" v-model="model.moeda_id" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" placeholder="moeda">
                        <option v-for="option in moedas" :key="option.id" :value="option.id">{{ option.nome }}</option>
                    </select>            
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Encomenda:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="model.encomenda_id" placeholder="Total">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Total:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="model.total" placeholder="Total">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.status" placeholder="Status">
                </div>
            </div>

            <div class="right w-[40vw] flex flex-col gap-2 rounded-[10px] bg-[var(--fundoApp)] p-4 ">
                <h3 class="text-[var(--titulo)]">Item Orçamento</h3>
                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Orcamento Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_orcamento_model.orcamento_id" placeholder="Orcamento Id">

                    <label class="min-w-[6.5rem]" for="data">Produto Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_orcamento_model.produto_id" placeholder="Produto Id">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Quantidade:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_orcamento_model.quantidade" placeholder="Quantidade">

                    <label class="min-w-[6.5rem]" for="data">Preço:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_orcamento_model.preco" placeholder="Preco">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Desconto:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_orcamento_model.desconto" placeholder="Desconto">

                    <label class="min-w-[6.5rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_orcamento_model.status" placeholder="Status">
                </div>

                <AppTable style="color: var(--titulo);" :visibility="true" :show="true" :table_data="produtos" table_title="Produtos"
                  @row-clicked="select_produto" @close="close_table" :show_multiSelect="false" />
                
            </div>

        </div>

    </div>

</template>


<script>
    import axios from 'axios';
    import AppButton from '@/components/button.vue'
    import AppTable from '@/components/tables/table.vue'
    export default {
        name: 'orcamento',
        components: {
            AppButton,
            AppTable
        },
        props: {
          fornecedor: {
              type: Object,
              default: {}
            },  
        },
        data() {
            return {
                baseURl: process.env.VUE_APP_URL_BASE,
                model: {
                    numero: '',
                    fornecedor: this.fornecedor.nome,
                    data: '',
                    validade: '',
                    prazo: 0,
                    moeda_id: 0,
                    encomenda_id: 0,
                    total: 0,
                    status: '',
                },
                item_orcamento_model:{
                    orcamento_id: 0,
                    produto_id: 0,
                    quantidade: 0,
                    preco: 0,
                    desconto: 0,
                    status: 0,
                },
                moedas:[],
                produtos:[],
                
            };
        },
        async created() {
            this.moedas= await this.select_all(`${this.baseURl}/api/v1/tpmoeda/`);
            this.produtos= await this.select_all(`${this.baseURl}/api/v1/produto/`);
            
            
        },
        methods: {
            close() {
                this.$emit('close');
            },
            async create(data, url) {
              try {
                  const res = await axios.post(url, data);
                  return res.data.data;
              } catch (error) {
                  console.error('Error getting data:', error);
              }
            },
  
        async select(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },
    
        async select_all(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
    
            } catch (error) {
                console.error('Error getting data:', error);
            }
    
        },
    
        async update(url, data) {
    
            try {
                const res = await axios.put(url, data);
                console.log('Data successfully updated:', res.data);
                return res.data.data;
    
            } catch (error) {
                console.error('Error posting data:', error);
            }
        },
    
        async remove(url) {
            // console.log("Data:", data.id)
            try {
                await axios.delete(url);
                return true;
            } catch (error) {
                console.error('Error deleting data:', error);
            }
        },
            
        }
    }

</script>



<style scoped>


</style>